import { Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';
import { StoreService } from '../../services/store.service';
import { ToolsService } from '../../services/tools.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

	constructor(private dataService: DataService
		, public storeService: StoreService
		, private toolsService: ToolsService
	) { }

	ngOnInit() { }

}
